import { createFeatureSelector, createSelector } from '@ngrx/store';
export const getFeatureFlagsState = createFeatureSelector('featureFlags');
/**
 * Selector to return all app level flags
 */
export const getAllAppFlags = createSelector(getFeatureFlagsState, (state) => state.app.flags);
/**
 * Selector to return current app project key
 */
export const getAppProjectKey = createSelector(getFeatureFlagsState, (state) => state.app.projectKey);
/**
 * Selector to get current status of a specific feature flag
 */
export const getAppFeatureFlag = (props) => createSelector(getFeatureFlagsState, (state) => state.app.flags[props.flag]);
/**
 * Selector to get initialization state
 */
export const getFeatureFlagInitializationStatus = createSelector(getFeatureFlagsState, (state) => state.initialized);
//# sourceMappingURL=feature-flag.selectors.js.map